import SearchIcon from "@mui/icons-material/Search";
import { Box, InputBase } from '@mui/material';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import axios from '../../common/api/axiosConfig';
import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import NewsMessage from '../../common/components/NewsMessage';
import { styles } from '../../style/style';
import { setOrderDetailData, setOrderSearchType } from '../orderdetail/orderDetailSlice';
import { add, setOrderRequestSearchType, setOrderRequestSearchField } from '../orderlist/orderListSlice';
import { setLogin } from '../userprofile/loginSlice';
import log from '../../common/components/Logger'


const LandingSearch = props => {

    const ApiList = useSelector((state) => state.apiList.apiList);
    const userDetails = useSelector((state) => state.user?.data?.payload);
    const childBacs = useSelector((state) => state.childBac?.data?.childBacs || []);
    const dispatch = useDispatch();
    const [errorMessage, setErrorMessage] = React.useState(null);
    const [invalidSearch, setInvalidSearch] = React.useState(null);
    const idToken = localStorage.getItem("idToken")
    const [enteredData, setEnteredData] = useState("");
    const [apiConfig, setApiConfig] = useState({
        headers: {
            method: 'POST',
            'Content-Type': 'application/json'
        }
    });


    useEffect(() => {
        dispatch(setLogin({ login: true }));
        console.log(userDetails);
        if (userDetails) {
            console.log(userDetails.country);
        }
    }, [])

    function submitHandler(e) {
        e.preventDefault()

        if (!userDetails) {
            setErrorMessage("USER_DATA_NOT_LOADED");
            return;
        }

        const normalizeBacs = (values) => [...new Set((values || [])
            .flatMap((value) => String(value || '').split(','))
            .map((value) => value.trim())
            .filter((value) => value !== ''))];
        const shipToBacsCsv = normalizeBacs([
            userDetails.shipToBacs,
            userDetails.shipToBac,
            userDetails.bac,
            ...childBacs
        ]).join(',');

        let dataSearch;
        const vinUrl = ApiList.vinsearch;
        const orderUrl = ApiList.ordernumsearch;
        let url;
        let navigatePath = "";


        if (selectedValue === 'vin') {
            if (userDetails.partnerType !== "GM_Corporate" && userDetails.partnerType !== "GM_Wholesale") {
                if(String(userDetails.partnerType || '').toUpperCase() === "UPFITTER"){
                    dataSearch = {
                    vinData: {
                        vin: enteredData,
                        bac: userDetails.bac,
                        partnerType: userDetails.partnerType,
                        shipToBacs: shipToBacsCsv
                    }

                };
                }else{
                    dataSearch = {
                    vinData: {
                        vin: enteredData,
                        bac: userDetails.bac,
                        partnerType: userDetails.partnerType,
                        fan: userDetails.primaryFan
                    }

                };
                }
                
            } else {
                dataSearch = {
                    vinData: {
                        vin: enteredData,
                        partnerType: userDetails.partnerType
                    }
                };
            }


            url = vinUrl;
            navigatePath = '/orderdetail';


            axios.post(url, dataSearch, apiConfig)
            .then((response) => {
                console.log(response)

                // if (response.data.vinValid) {
                //     console.log("success")
                //     //navigate(navigatePath);
                // } else {
                //     console.log(response.data.statusMessage);
                // }

                if (response.data.statusMessage === 'SUCCESS' || response.data.statusMessage === null) {
                    if (response.data.orderDetail) {
                        log.info(`fos_ui_log: LandingSearch():orderDetail: Successful Fetch! ${response.data.orderDetail}`)
                        dispatch(setOrderSearchType('leftClick'));
                        dispatch(setOrderDetailData(response.data.orderDetail));
                        window.location.href = navigatePath;
                    }    

                } else if (response.data.statusMessage === 'INVALID_VIN'){
                    log.info(`fos_ui_log: LandingSearch(): ${response.data.statusMessage}`)
                    setErrorMessage(response.data.statusMessage);
                } else if (response.data.statusMessage === 'VIN_NOT_FOUND'){
                    log.info(`fos_ui_log: LandingSearch(): ${response.data.statusMessage}`)
                    setErrorMessage(response.data.statusMessage);
                } else if(response.data.statusMessage==="VIN_NOT_ENTERED"){
                    log.info(`fos_ui_log: LandingSearch(): ${response.data.statusMessage}`)
                    setErrorMessage("VIN_NOT_ENTERED"); 
                } else{
                    setErrorMessage("ERROR")
                }

                
            })
            .catch((error) => {
                log.error(`fos_ui_log: LandingSearch(): ${error.message}`)
                setErrorMessage("THERE_WAS_TROUBLE_ACCESSING_THE_DATA");
            })






        } else {
            if (userDetails.partnerType !== "GM_Corporate" && userDetails.partnerType !== "GM_Wholesale") {
                if (String(userDetails.partnerType || '').toUpperCase() === "UPFITTER") {
                    dataSearch = {
                    orderData: {
                        orderNumbers: enteredData,
                        shipToBacs: shipToBacsCsv,
                        partnerType: userDetails.partnerType,
                        fan: userDetails.primaryFan
                    }
                }
                }else{
                    dataSearch = {
                    orderData: {
                        orderNumbers: enteredData,
                        bac: userDetails.bac,
                        partnerType: userDetails.partnerType,
                        fan: userDetails.primaryFan
                    }
                }
                }
                
            } else {
                dataSearch = {
                    orderData: {
                        orderNumbers: enteredData,
                        partnerType: userDetails.partnerType,
                        fan: userDetails.primaryFan
                    }
                }
            }

            url = orderUrl;
            navigatePath = '/orderrequestlist';

            dispatch(setOrderRequestSearchType('OrderListLanding'));
            dispatch(setOrderRequestSearchField(dataSearch));
            window.location.href = navigatePath;
        };




        /*
        axios.post(url, dataSearch, apiConfig)
            .then((response) => {
                console.log(response)

                // if (response.data.vinValid) {
                //     console.log("success")
                //     //navigate(navigatePath);
                // } else {
                //     console.log(response.data.statusMessage);
                // }

                if (response.data.statusMessage === 'SUCCESS' || response.data.statusMessage === null) {
                    if (response.data.orderRequestList) {
                        log.info(`fos_ui_log: LandingSearch():orderRequestList: Successful Fetch! ${response.data}`)
                        dispatch(setOrderRequestSearchType('leftClick'));
                        dispatch(add(response.data));
                        window.location.href = navigatePath;
                    } else {
                        if (response.data.ordersNotFoundMessage){//invalid order number 
                            setErrorMessage(response.data.ordersNotFoundMessage);
                            log.info(`fos_ui_log: LandingSearch():orderRequestList: ${response.data.ordersNotFoundMessage}`)
                        //  setErrorMessage(intl.formatMessage({ id: response.data.ordersNotFoundMessage, defaultMessage: "Error Found" })) //
                        }

                        if (response.data.invalidOrdersMessage){//empty order number
                            setErrorMessage(response.data.invalidOrdersMessage);
                            log.info(`fos_ui_log: LandingSearch():orderRequestList: ${response.data.invalidOrdersMessage}`)
                        // setErrorMessage(intl.formatMessage({ id: response.data.invalidOrdersMessage, defaultMessage: "Error Found" })); //
                        }
                    }

                    if (response.data.orderDetail) {
                        log.info(`fos_ui_log: LandingSearch():orderDetail: Successful Fetch! ${response.data.orderDetail}`)
                        dispatch(setOrderSearchType('leftClick'));
                        dispatch(setOrderDetailData(response.data.orderDetail));
                        window.location.href = navigatePath;
                    } else {
                        if (response.data.ordersNotFoundMessage){//invalid order number
                            log.info(`fos_ui_log: LandingSearch():orderDetail: ${response.data.ordersNotFoundMessage}`)
                            setErrorMessage(response.data.ordersNotFoundMessage);
                        // setErrorMessage(intl.formatMessage({ id: response.data.ordersNotFoundMessage, defaultMessage: "Error Found" })) //
                        }

                        if (response.data.invalidOrdersMessage){//empty order number
                            log.info(`fos_ui_log: LandingSearch():orderDetail: ${response.data.invalidOrdersMessage}`)
                            setErrorMessage(response.data.invalidOrdersMessage);
                        // setErrorMessage(intl.formatMessage({ id: response.data.invalidOrdersMessage, defaultMessage: "Error Found" })); //
                        }

                        if (response.data.invalidSearchItem){//invalid order number
                            setInvalidSearch(response.data.invalidSearchItem)
                        }
                    
                    }
                } else if (response.data.statusMessage === 'INVALID_VIN'){
                    log.info(`fos_ui_log: LandingSearch(): ${response.data.statusMessage}`)
                    setErrorMessage(response.data.statusMessage);
                }else if (response.data.statusMessage === 'VIN_NOT_FOUND'){
                    log.info(`fos_ui_log: LandingSearch(): ${response.data.statusMessage}`)
                    setErrorMessage(response.data.statusMessage);
                }
                 else if(response.data.statusMessage==="VIN_NOT_ENTERED"){
                    log.info(`fos_ui_log: LandingSearch(): ${response.data.statusMessage}`)
                    setErrorMessage("VIN_NOT_ENTERED"); 
                }else{
                    setErrorMessage("ERROR")
                }

            })
            .catch((error) => {
                log.error(`fos_ui_log: LandingSearch(): ${error.message}`)
                setErrorMessage("THERE_WAS_TROUBLE_ACCESSING_THE_DATA");
            })*/
    }

    function arrayToObject(arr) {
        var obj = {};
        for (var i = 0; i < arr.length; ++i) {
            obj[i] = arr[i];
        }
        return obj;
    }


    const intl = useIntl();
    const options = [{ label: intl.formatMessage({ id: "landingsearch.ordertype", defaultMessage: "try" }), value: 'order' }, {
        label: intl.formatMessage({ id: "landingsearch.vintype", defaultMessage: "try" }), value: 'vin'
    }];

    let selectValue = { label: intl.formatMessage({ id: "landingsearch.ordertype", defaultMessage: "try" }), value: 'order' };

    const orderSearchMessage = { label: intl.formatMessage({ id: "landingsearch.ordermessage", defaultMessage: "try" }), value: 'orderSearch' };
    const vinSearchMessage = { label: intl.formatMessage({ id: "landingsearch.vinmessage", defaultMessage: "try" }), value: 'vinSearch' };
    const [searchLable, setLabel] = useState(orderSearchMessage.label);



    function onChangeEntry(event) {
        setEnteredData(event.target.value);
    }

    const [selectedValue, setSelected] = useState(options[0].value);

    const onChangeSelected = (event) => {
        setSelected(event.target.value);
    }
    

    let placeholder;
    if (selectedValue === 'vin') {
        placeholder = vinSearchMessage.label
    } else {
        placeholder = orderSearchMessage.label
    }


    /*
    const [errorType, setErrorType] = React.useState("");
    const [open, setOpen] = React.useState(false);
    const handleAlertClose = (reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };
    */


    return (
        <Box sx={styles.homePageMargin}>
            <Typography id='landingTitle' variant="h2" sx={styles.h2PageTitle}>
                <FormattedMessage
                    id='landingsearch.appname'
                    defaultMessage='Vehicle Order Status'
                />
            </Typography>
            <br />
            
            <Typography id='landingMessage' variant="body1" sx={styles.pBodyText}>
                <FormattedMessage
                    id='landingsearch.message'
                    defaultMessage='Track your fleet orders. View shipments.'
                />
            </Typography>
            <br></br>
            <br></br>
            
            <Grid container spacing={2} columns={12}>
                <Grid size={{ xs: 12, sm: 12, md: 6 }}>
                    <Typography id='landingSearchDescription' variant="h3" sx={styles.h3SectionTitle}>
                        <FormattedMessage
                            id='landingsearch.searchdescription'
                            defaultMessage='Search Orders By Order Number or VIN'
                        />
                    </Typography>
                            {/* <Typography variant='body1' sx={styles.errorSxLanding}>{errorMessage}</Typography> */}
                            {errorMessage !== null &&
                                <Typography id='landingError' variant='body1' sx={styles.errorSxLanding}><FormattedMessage id={errorMessage} defaultMessage='Error Found' /> 
                                {/* {invalidSearch} */}
                                </Typography>
                            }
                               
                            <br />
                            <Stack direction='row' spacing={0}>
                                <Box component="form" backgroundColor='#D9D9D6'
                                    sx={{ display: 'flex', alignItems: 'center', height: 50, width: '100%', maxWidth: 600 }}>
                                    <Select
                                        style={{ textAlign: "center" }}
                                        inputProps={{ style: { textAlign: 'center' } }}
                                        MenuProps={{ disableScrollLock: true }}
                                        sx={styles.selectSxLanding}
                                        labelId="searchTypesLabel"
                                        id="landingSearchTypes"
                                        value={selectedValue}
                                        displayEmpty
                                        name="searchTypes"
                                        onChange={onChangeSelected}
                                        variant="standard"
                                        disableUnderline
                                    >
                                        {options.map(option => {
                                            return <MenuItem id={option.value} sx={styles.menuItemSxLanding} key={option.value} value={option.value}>{option.label}</MenuItem>
                                        })}
                                    </Select>
                                    {/* <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" /> */}
                                    {/* <TextField
                                    sx={searchSx}
                                    size="small"
                                    id="textData"
    
                                    InputLabelProps={{ style: { fontSize: 12 } }}
                                    label={searchLable}
                                    variant="standard"
                                    onChange={onChangeEntry}
                                /> */}

                                    <InputBase
                                        id='landingSearchBox'
                                        sx={styles.searchSxLanding}
                                        inputlabelprops={{ style: { fontSize: 12, color: 'black' } }}
                                        placeholder={placeholder}
                                        onChange={onChangeEntry}
                                        value={enteredData}
                                    />
                                    {/* <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" /> */}
                                    <Button
                                        id='landingSearchButton'
                                        sx={styles.buttonSxLanding}
                                        type="submit"
                                        aria-label='Search'
                                        startIcon={<SearchIcon></SearchIcon>}
                                        onClick={submitHandler}
                                        variant="standard"
                                    >
                                    </Button>

                                </Box>
                            </Stack>
                            <br></br>
                            {placeholder === orderSearchMessage.label && (
                            <Box sx={{ ...styles.homepageBoxShadow, maxWidth: '600px', width: '100%' }}>
                                <Typography id='landingSearchNote' variant="body1" sx={styles.pBodyText}>
                                    <FormattedMessage
                                        id='landingsearch.note'
                                        defaultMessage='Note: To search for up to five orders, type in each order number separated by a comma with no spaces. Ex: 123345678,123343245'
                                    />
                                </Typography>
                            </Box>)}
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 5 }}>
                    <NewsMessage />
                </Grid>
            </Grid>
            {/* {errorMessage !== null &&
                <ErrorSnackbarNotification errorType={errorType} open={open} handleClose={handleAlertClose} errorMessage={errorMessage} />
            } */}
        </Box>
    )
}

export default LandingSearch;




